import React from 'react';
import PropTypes from 'prop-types';

import { Box, Flex, Text, SvgIcon } from '../../Base';

const NextSubsectionPanel = ({ title, subsectionName, onNext, ...restProps }) => {
  return (
    <Box width={1} p={5} {...restProps}>
      <Text mb={4} color={'inherit'}>
        {title}
      </Text>
      <Flex alignItems={'start'}>
        <SvgIcon
          icon={SvgIcon.ICON_LIST.VIDEO_PLAY_CIRCLE}
          size={24}
          mr={5}
          color={'inherit'}
          style={{ flexShrink: 0 }}
        />
        <Text
          onClick={onNext}
          color={'inherit'}
          style={{
            cursor: 'pointer',
            WebkitLineClamp: '2',
            WebkitBoxOrient: 'vertical',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            display: '-webkit-box',
          }}
        >
          {subsectionName}
        </Text>
      </Flex>
    </Box>
  );
};

NextSubsectionPanel.propTypes = {
  title: PropTypes.string,
  subsectionName: PropTypes.string,
};

export default NextSubsectionPanel;
